module.exports = __webpack_public_path__ + "static/img/minicon3.ca74e031.png";